<div class="ya-page-content ya-page-content--padding ya-page-content--webshop">
  <div class="revoke-order-result">

    <ng-container *ngIf="outcome === 'success'">
      <div class="inline-icon revoke-order-result-icon revoke-order-result-icon--success" inlineSVG="shop-icons.svg#ya-done"></div>
      <h2 class="revoke-order-result-headline" langkey="phRevokeOrder_ResultSuccessHeadline1"></h2>
      <h2 class="revoke-order-result-headline" langkey="phRevokeOrder_ResultSuccessHeadline2"></h2>
      <span class="revoke-order-result-subtext" langkey="phRevokeOrder_ResultSuccessSubtext"></span>
    </ng-container>

    <ng-container *ngIf="outcome === 'error'">
      <div class="inline-icon revoke-order-result-icon revoke-order-result-icon--error" inlineSVG="shop-icons.svg#ya-hypersoft-Fail"></div>
      <h2 class="revoke-order-result-headline" langkey="phRevokeOrder_ResultErrorHeadline"></h2>
      <span class="revoke-order-result-subtext" langkey="phRevokeOrder_ResultErrorSubtext"></span>
    </ng-container>

    <div class="ya-webshop-button-container">
      <button mat-flat-button a11y_Button (click)="goHome()">
        <span langkey="phOrderResult_ToTheHomescreen"></span>
      </button>
    </div>

  </div>
</div>
